module.exports = __webpack_public_path__ + "img/reach-work.2d3df07f.jpg";